import React, { useState, useEffect } from 'react';
import moment from 'moment'
import OrderForm from "../../order/components/ModalFormOrder";
import Modal from "../../../components/molecules/Modal";
import {deleteOrder, updateOrderStatus} from "../../../store/action/order";
import {isContainText, isCourier, isPhoneNumber} from "../../../services/helpers/validator";
import {trackEvent} from "../../../services/analytics";
import {createCourierBook} from "../../../store/action/courier";
import { OrderTable } from "../../order/components";
import Maps from "../../../components/atoms/Maps";
import LoadingBar from "react-top-loading-bar";
import {getAdminUserAddress,getAdminUserOrders} from "../../../store/action/user";
import {createAdminOrder} from "../../../store/action/order";

const AdminUserOrders = ({user,token}) => {
    const [ tab, setTab ] = useState('active');
    const [ progress, setProgress ] = useState(0);
    const [ addresses, setAddresses ] = useState([]);
    const [ loadings, setLoadings ] = useState({
        origin:false,
        destination:false,
        couriers:false
    });
    const [ show, setShow ] = useState({
        modal:false,
        modalType:'order',
        map:false,
        mapType:'origin'
    });
    const [ values, setValues ] = useState({
        activeOrders:[],
        details:'',
        cancelReasons:[],
        cancellationReason:'',
        courierOption:[],
        courierOptionFiltered:[],
        courierWaybillId:'',
        courierCompany: 'gojek',
        courierType: '',
        courierName:'',
        courierPhone: '',
        courierLink: '',
        courierLoading: false,
        deliveryType: 'now',
        deliveryDate: new Date() ,
        deliveryTime: moment().format('HH:mm:ss'),
        error:false,
        finishedOrders:[],
        historyOrders:[],
        information:'',
        info:false,
        needActionOrders:[],
        loading: true,
        locationLoading:false,
        paymentMethod:'',
        price:0,
        scheduledOrders:[],
        serviceType:'sameDay',
        shippingType:'parcel',
        weight:0,
        volume:0,
        success:false,
        paymentType:'',
        status:'active'
    });

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        const resOr = await getAdminUserOrders(user.id,token);
        addProgress(20);
        if(!(resOr)) {
            return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
        }
        if(resOr.success) {
            let orders = resOr.orders.reduce((result, i, idx) => {
                result.push({
                    cancellationReason: i.cancellationReason,
                    courierTrackingId: i.courier.trackingId,
                    courierWaybillId: i.courier.waybillId,
                    courierCompany: i.courier.company,
                    courierType: i.courier.type,
                    courierName: i.courier.name,
                    courierPhone: i.courier.phone,
                    courierLink: i.courier.link,
                    createdAt: i.createdAt,
                    deliveryType: i.delivery.type,
                    deliveryDate: i.delivery.date,
                    deliveryTime: i.delivery.time,
                    deliveryNote: i.delivery.note,
                    extra: i.extra,
                    items: i.items,
                    orderId: i._id,
                    orderType: i.type,
                    originName: i.origin.name,
                    originLocation: i.origin.location,
                    originPhone: i.origin.phone,
                    originNote: i.origin.note,
                    orderNote: i.note,
                    price: i.price,
                    paymentType: i.paymentType,
                    paymentMethod: i.paymentMethod,
                    paymentSlip: i.images.paymentSlip,
                    receiverName: i.receiver.name,
                    receiverPhone: i.receiver.phone,
                    receiverLocation: i.receiver.location,
                    receiverCOD: i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.amount : null,
                    receiverNote:i.receiver.note,
                    receiptLink: i.receiptLink,
                    status: i.status
                });
                return result
            }, []);

            orders = orders.sort((a, b) => {
                var dateA = new Date(a.deliveryDate);
                var dateB = new Date(b.deliveryDate);
                return dateB - dateA;
            });

            let activeOrders = orders.filter(i =>
                i.status !== 'cancelled' &&
                i.status !== 'placed' &&
                i.status !== 'delivered' &&
                i.status !== 'rejected'
            );

            let scheduledOrders = orders.filter(i =>
                i.status === 'placed'
            );

            let finishedOrders = orders.filter(i =>
                i.status === 'delivered' ||
                i.status === 'cancelled'
            );

            let needActionOrders = orders.filter(i =>
                i.status === 'rejected' ||
                i.status === 'courierNotFound'
            );

            setValues({
                ...values,
                historyOrders:orders,
                activeOrders,
                finishedOrders,
                scheduledOrders,
                needActionOrders,
                loading:false
            });

            setAddresses(addresses);
        } else {
            return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
        }
        progressComplete();
    };

    const addProgress = value => {
        setProgress(value);
    };

    const progressComplete = () => {
        setProgress(100);
    };

    const onUpdateOrder = (orderId, status) => {
        if(window.confirm('Kami akan segera mempesan order kamu. Kamu yakin?')) {
            updateOrderStatus(token, orderId, status)
                .then(res => {
                    if(res.success){
                        alert(`Kami segera mempesan. Mohon ditunggu :)`);
                        window.location.reload()
                    } else {
                        alert(res.error)
                    }
                })
        }
    };

    const onOrderCourier = orderId => {
        if(window.confirm('Kami akan segera mempesan order kamu. Kamu yakin?')) {
            createCourierBook(token, orderId)
                .then(res => {
                    if(res.success){
                        alert(`Kami segera mempesan. Mohon ditunggu :)`);
                        window.location.reload()
                    } else {
                        alert(res.message)
                    }
                })
        }
    };

    const onShowDeleteModal = async (orderId, type) => {
        let cancelReasons;
        if (type === 'form') {
            cancelReasons = [
                "Pilih...",
                "Customer ingin ganti orderan",
                "Jumlah transfer customer beda dengan bukti transfer",
                "Lainnya"
            ];
        } else {
            cancelReasons = [
                "Pilih...",
                "Ingin mengganti kurir",
                "Ingin mengganti alamat",
                "Harga kurir tidak sesuai",
                "Lainnya"
            ];
        }
        setValues({
            ...values,
            orderId,
            cancelReasons
        });
        setShow({
            modal:true,
            modalType:'delete'
        })
    };

    const onSelectCancelReason = e => {
        setValues({...values, cancellationReason:e.target.value})
    };

    const onDeleteOrder = async () => {
        if (values.cancellationReason === '' || values.cancellationReason === 'Pilih...') {
            alert("Pilih alasan kenapa Anda cancel.");
            return
        }
        await addProgress(20);
        deleteOrder(token, values.orderId, values.cancellationReason)
            .then(async res => {
                if(res.success){
                    await trackEvent("Order Cancelled",{
                        action: "track",
                        category: "Orders",
                        label: 'Cancel Order From Dashboard',
                        event: "Click"
                    });

                    alert(`Berhasil dihapus`);
                    window.location.reload()
                } else {
                    alert(res.error)
                }
                progressComplete();
            });
    };

    const orderTable = () => {
        let tabOrders;
        if (tab === 'finished') {
            tabOrders = values.finishedOrders
        } else if (tab === 'active') {
            tabOrders = values.activeOrders
        } else if (tab === 'action') {
            tabOrders = values.needActionOrders
        }else if (tab === 'scheduled') {
            tabOrders = values.scheduledOrders
        }

        return (
            <OrderTable
                data={tabOrders}
                loading={values.loading}
                onUpdateOrder={onUpdateOrder}
                onOrderCourier={onOrderCourier}
                onDeleteOrder={onShowDeleteModal}
            />
        )
    };

    const handleModalClose = () => {
        setShow({...show, modal:false})
    };


    const modalView = () => {
        if (show.modalType === 'order') {
            return (
                <OrderForm
                    show={show.modal}
                    onHide={handleModalClose}
                    admin={true}
                    user={user}
                />
            )
        } else {
            return (
                <Modal
                    show={show.modal}
                    onHide={handleModalClose}
                    title={"Alasan Cancel"}
                    size={"md"}
                    bodyClassName="p-0"
                    buttons
                    type={"oneButton"}
                    bText={`Lanjut Batalkan`}
                    bClick={() => onDeleteOrder()}
                >
                    <div className="p-4">
                        <select
                            id="inputState"
                            className="form-control"
                            onChange={e => onSelectCancelReason(e)}
                        >
                            {
                                values.cancelReasons.map((i,idx) => (
                                    <option
                                        key={idx}
                                        value={i}
                                        className={`${idx === 0 ? "selected":""}`}
                                    >
                                        {i}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                </Modal>
            );
        }
    };

    const onClickOrderSection = () => {
        if (!user.phone ) {
            alert("Mohon masukkan nomor telepon terlebih dahulu di bagian Pengaturan");
            return
        }
        if (!user.organizationName) {
            alert("Mohon masukkan nama perusahaan terlebih dahulu di bagian Pengaturan");
            return
        }
        if (show.modal){
            setShow({...show,modal:false})
        } else {
            setShow({modalType: 'order',modal:true});
            setValues({
                ...values,
                courierOption:[],
                courierOptionFiltered:[],
                receiverLocation:'',
                receiverPostalCode: '-',
                receiverCoordinate: {},
                receiverProvinceName:'-',
                receiverCityName:'-',
                receiverDistrictName:'-'
            });
        }
    };

    return (
        <div>
            <div className="bg-white rounded shadow">
                <LoadingBar progress={progress} color='#059fe6' height={5}/>
                { modalView() }
                <div className="p-4">
                    <div className=" d-flex justify-content-between">
                        <h5>List Pesanan </h5>
                        <div className="row">
                            <button className="btn btn-secondary mr-3" onClick={() => setTab('scheduled')}>
                                Terjadwal ({values.scheduledOrders.length})
                            </button>
                            <button className="btn btn-secondary mr-3" onClick={() => setTab('active')}>
                                Berlangsung ({values.activeOrders.length})
                            </button>
                            <button className="btn btn-secondary mr-3" onClick={() => setTab('action')}>
                                Butuh Tindakan ({values.needActionOrders.length})
                            </button>
                            <button className="btn btn-secondary mr-3" onClick={() => setTab('finished')}>
                                Selesai
                            </button>
                            <button
                                className="btn btn-primary mr-3"
                                onClick={onClickOrderSection}
                            >
                                Kirim Barang
                            </button>
                        </div>
                    </div>
                </div>
                { orderTable() }
            </div>
        </div>
    )
};


export default AdminUserOrders;
